'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { Shield, Scale, Cookie, AlertCircle, FileText } from 'lucide-react';

export default function LegalSidebar() {
    const pathname = usePathname();

    const links = [
        { href: '/terms', label: 'Terms of Service', icon: Scale },
        { href: '/privacy-policy', label: 'Privacy Policy', icon: Shield },
        { href: '/cookie-policy', label: 'Cookie Policy', icon: Cookie },
        { href: '/disclaimer', label: 'Disclaimer', icon: AlertCircle },
    ];

    return (
        <aside className="space-y-8">
            <div className="bg-[var(--bg-elevated)] border border-[var(--color-border)] rounded-xl p-6">
                <h3 className="font-heading font-bold text-[var(--color-text-main)] mb-4 px-2">Legal Documents</h3>
                <nav className="space-y-1">
                    {links.map((link) => {
                        const Icon = link.icon;
                        const isActive = pathname === link.href;

                        return (
                            <Link
                                key={link.href}
                                href={link.href}
                                className={`flex items-center gap-3 px-3 py-2.5 rounded-lg transition-all duration-200 ${isActive
                                    ? 'bg-[var(--color-primary)] text-white font-medium shadow-md'
                                    : 'text-[var(--color-text-muted)] hover:bg-[var(--bg-secondary)] hover:text-[var(--color-text-main)]'
                                    }`}
                            >
                                <Icon size={18} />
                                <span className="text-sm">{link.label}</span>
                            </Link>
                        );
                    })}
                </nav>
            </div>

            <div className="bg-[var(--bg-secondary)] border border-[var(--color-border)] rounded-xl p-6">
                <div className="flex items-start gap-4">
                    <FileText className="text-[var(--color-primary)] mt-1 shrink-0" size={20} />
                    <div>
                        <h4 className="font-bold text-[var(--color-text-main)] text-sm mb-2">Need Help?</h4>
                        <p className="text-[var(--color-text-muted)] text-xs mb-3 leading-relaxed">
                            For specific legal inquiries or data protection requests, please contact our implementation officer.
                        </p>
                        <a href="mailto:info@carsite.co.za" className="text-xs font-bold text-[var(--color-primary)] hover:underline">
                            info@carsite.co.za
                        </a>
                    </div>
                </div>
            </div>
        </aside>
    );
}
